import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import PictureComp from '@/components/picture/PictureComp.vue';
import StreamingChartsTrend from '@/features/editorial/components/home/modules/blocks/streaming-charts/StreamingChartsTrend.vue';

import { type StreamingChartsTitle } from '@/features/editorial/types/editorial-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideStreamingChartsItem',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
	title: StreamingChartsTitle;
};



const streamingChartInfo = computed(() => props.title.streamingCharts.edges?.[0].streamingChartInfo);

return { __sfc: true,props, streamingChartInfo, PictureComp, StreamingChartsTrend }
}

})